// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {MarkdownEl} from '../markdown';
import {SvgIconEl} from '../svg-icon';
import type {TextHighlight} from './index';

export function template(this: TextHighlight) {
  const icon = this.attr(`icon`);
  const textBefore = this.attr(`text-before-icon`);

  return (
    <span>
      <div
        attrs={{
          elref: `textHighlight`,
        }}
        sel='.mp-text-highlight'
        class={{
          [this.attr(`theme`)]: true,
          [`size-${this.attr(`size`)}`]: true,
          [`length-${this.attr(`length`)}`]: true,
          [`no-wrap`]: this.attr(`no-wrap`),
        }}
      >
        {icon && !textBefore && <SvgIconEl attrs={{icon}} />}
        {this.attr(`text`) && <div sel='.text'>{this.attr(`text`)}</div>}
        {this.attr(`markdown`) && (
          <div sel='.markdown.text'>
            <MarkdownEl attrs={{text: this.attr(`markdown`)}} />
          </div>
        )}
        {icon && textBefore && <SvgIconEl attrs={{icon}} class={{'text-before-icon': true}} />}
      </div>
      <slot />
    </span>
  );
}
